/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import authReducer from 'src/slices/auth/authSlice'
import calculationDSLsReducer from 'src/slices/calculationDSLs/calculationDSLsSlice'
import calculationGroupsReducer from 'src/slices/calculationGroups/calculationGroupsSlice'
import calculationItemsReducer from 'src/slices/calculationItems/calculationItemsSlice'
import confirmSalesReportReducer from 'src/slices/confirmSalesReport/confirmSalesReportSlice'
import definiteValuesReducer from 'src/slices/definiteValues/definiteValuesSlice'
import editCalculationsReducer from 'src/slices/editCalculations/editCalculationsSlice'
import editTenantsReducer from 'src/slices/editTenants/editTenantsSlice'
import messageReducer from 'src/slices/message/messageSlice'
import navigationReducer from 'src/slices/navigation/navigationSlice'
import ocrFormatsReducer from 'src/slices/ocrFormats/ocrFormatsSlice'
import profileReducer from 'src/slices/profile/profileSlice'
import queryReducer from 'src/slices/query/querySlice'
import salesReportsReducer from 'src/slices/salesReports/salesReportsSlice'
import snackbarReducer from 'src/slices/snackbar/snackbarSlice'
import storesReducer from 'src/slices/stores/storesSlice'
import storeSalesReportSummariesReducer from 'src/slices/storeSalesReportSummaries/storeSalesReportSummariesSlice'
import tenantsReducer from 'src/slices/tenants/tenantsSlice'
import tenantSalesReportSliceReducer from 'src/slices/tenantSalesReports/tenantSalesReportsSlice'
import tenantSalesReportSummariesReducer from 'src/slices/tenantSalesReportSummaries/tenantSalesReportSummariesSlice'

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [],
}

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['status', 'error'],
}

const queryPersistConfig = {
  key: 'query',
  storage,
  blacklist: [],
}

const navigationPersistConfig = {
  key: 'navigation',
  storage,
  whitelist: ['currentRoot'],
}

const editCalculationsPersistConfig = {
  key: 'editCalculations',
  storage,
  blacklist: [],
}

const confirmSalesReportConfig = {
  key: 'confirmSalesReport',
  storage,
  blacklist: [],
}

const definiteValuesConfig = {
  key: 'definiteValues',
  storage,
  blacklist: [],
}

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  navigation: persistReducer(navigationPersistConfig, navigationReducer),
  query: persistReducer(queryPersistConfig, queryReducer),
  message: messageReducer,
  snackbar: snackbarReducer,
  forms: combineReducers({
    editTenants: editTenantsReducer,
    editCalculations: persistReducer(
      editCalculationsPersistConfig,
      editCalculationsReducer
    ),
    confirmSalesReport: persistReducer(
      confirmSalesReportConfig,
      confirmSalesReportReducer
    ),
    definiteValues: persistReducer(definiteValuesConfig, definiteValuesReducer),
  }),
  entities: combineReducers({
    stores: storesReducer,
    tenants: tenantsReducer,
    calculationDSLs: calculationDSLsReducer,
    calculationItems: calculationItemsReducer,
    calculationGroups: calculationGroupsReducer,
    ocrFormats: ocrFormatsReducer,
    salesReports: salesReportsReducer,
    storeSalesReportSummaries: storeSalesReportSummariesReducer,
    tenantSalesReportSummaries: tenantSalesReportSummariesReducer,
    tenantSalesReports: tenantSalesReportSliceReducer,
    profile: profileReducer,
  }),
})

export default persistReducer(rootPersistConfig, rootReducer)
